// extracted by mini-css-extract-plugin
module.exports = {"loading":"loader_loading__1ykC0","dot":"loader_dot__Jdq1u","wave":"loader_wave__DlnuS"};